<template>
    <v-row no-gutters class="wrapper offline">

      <v-col class="form">
          <img :style="`margin-top: 40px; width: ${localConfig.logo && localConfig.logo.tamanho}%`" :src="localConfig.logo && localConfig.logo.img" alt="">
          <h1 style="text-align: center; font-weight: 500; font-size: 28px">{{localConfig.logo && localConfig.logo.titulo}}</h1>
          <p class="form-title">{{localConfig.textos && localConfig.textos.offline}}</p>
          <form autocomplete="off">
              <input v-model="user.nome" autocomplete="new-password" placeholder="Nome">
              <input v-model="user.telefone" v-mask="['(##) #####-####', '(##) ####-####']" autocomplete="new-password" placeholder="Telefone">
              <!-- <input v-model="user.email" autocomplete="new-password" placeholder="Email (Opcional)"> -->
              <textarea rows="4" v-model="msg" placeholder="Sua mensagem"></textarea>
              <v-btn color="primary" block :disabled="!user.nome || !user.telefone || isLoading" @click="sendMsg">
                  <v-progress-circular size="18" width="2.5" v-if="isLoading" indeterminate color="#272727"></v-progress-circular>
                  Deixar Mensagem
              </v-btn>
          </form>
      </v-col>
    </v-row>
</template>

<script>

import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import axios from "axios";

export default {
    nome: "signin",
    data: () => ({
      msg: null,
      user: {},
      isLoading: false,
      localConfig: {},
    }),
    mounted(){
      this.localConfig = JSON.parse(localStorage.getItem('@bsi:config'));
    },
    sockets:{
      connect: function () {
        console.log('socket connected');
      }
    },
    methods: {
      async sendMsg(){

        const { empID } = this.$route.params;

        try {

          let obj = {
            nome: this.user.nome,
            telefone: this.user.telefone,
            mensagem: this.msg
          };

          this.isLoading = true;

          const request = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/public/mensagem/${empID}`, obj);
          const response = request.data;

          this.$router.push({name: 'Success'});

        } catch (error) {
          console.log(error);
        } finally {
          this.isLoading = false;
        }

      },
      async save(){

        try {

          const { empID } = this.$route.params;

          let obj = {
            nome: this.user.nome,
            telefone: this.user.telefone,
          };

          this.isLoading = true;

          const request = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/public/clientes/${empID}`, obj);
          const { payload, token } = request.data;

          localStorage.setItem('@bsi:user', JSON.stringify(payload));
          localStorage.setItem('@bsi:token', token);

          this.$router.push({name: 'Waiting'});

        } catch (error) {
          console.log(error);
        } finally {
          this.isLoading = false;
        }
       
      }
    }
}
</script>

<style lang="scss">
  .v-btn{
    &.primary{
      span{
        color: var(--v-btnText-base);
      }
    }
  }
</style>

<style lang="scss" scoped>

  .wrapper{
    background-color: var(--v-secondary-base);
    color: var(--v-text-base);
    overflow: hidden;

    
      

    &.offline{
      padding-bottom: 30px;
      max-width: 400px;

      .form img{
        margin-top: 10px;
      }
      
    }

    &.online{
      width: 95vw;
      height: 80vh;
      min-height: 500px;
    }
  }

  .background{
    -webkit-transition: all 1.5s ease-in-out;
    -o-transition: all 1.5s ease-in-out;
    -moz-transition: all 1.5s ease-in-out;
    transition: all 1.5s ease-in-out;
    z-index: 1;
    opacity: .4;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  .content{
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1{
      text-align: center;
      width: 75%;
      font-size: 32px;
    }

    h4{
      text-align: center;
      width: 75%;
      margin: 10px 0;
      font-size: 14px;
      letter-spacing: .8;
      font-weight: normal;
    }

    a{
      margin: 20px 0;
    }
  }

  .banner{
    position: relative;
    background-color: black;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .form{
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 30px 0;

    .form-title{
      padding: 20px 0;
      text-align: center;
      font-size: 13px;
      width: 80%;
      display: block;
      margin: 0 auto;
    }

    .subtitle{
      padding: 20px 0;
      text-align: center;
      font-size: 12px;
      width: 80%;
      display: block;
      margin: 0 auto;
    }
    img{
      display: block;
      margin: 0 auto;
    }
    .agree-text{
      font-size: 13px;
      a{
        text-decoration: none;
      }
    }
    form{
      padding: 5px 30px;
      input, textarea{
        width: 100%;
        color: var(--v-texts-base);
        font-size: 14px;
        padding: 10px;
        margin: 10px 0;
        border-radius: 4px;
        border: 1px solid var(--v-texts-base);
        &::placeholder {
          color: var(--v-texts-base);
        }
        &:focus{
          outline-width: 0;
          outline: none;
        }
      }

      .v-btn{
        .v-progress-circular{
          margin-right: 10px;
          color: var(--v-texts-base);
        }
      }
    }
  }

  @media screen and (min-width: 1200px) {
    
    .wrapper{

      &.online{
        width: 80vw;
      }

    }

  }

  @media screen and (max-width: 480px) {
    
    .wrapper{

      &.online{
        width: 90vw;
      }
      
      .banner{
        display: none !important;
      }

    }

  }
</style>